module.exports = __webpack_public_path__ + "img/iotwise1.215be11d.png";